import { createFileRoute } from '@tanstack/react-router'
import { AppConfigPage } from 'pages/appConfig/AppConfigPage'
import { appConfigSearchParams } from 'routes/app-config/-searchParams'

export const Route = createFileRoute('/app-config/')({
  component: AppConfigPage,
  validateSearch: appConfigSearchParams,
  staticData: {
    title: 'App Configuration',
    layout: {
      enableScrolling: true,
      showNavbar: true,
    },
  },
})
